import { Injectable } from '@angular/core';
import { AppService } from '../../../../../core/service/Base.Service';


@Injectable()
export class StateService extends AppService<any> {

    constructor() {
        super('State');
    }

    async getState() {
        const result = await this.get('');
        return result;

    }

    async getStateByCountry(country) {

        if (country > 0) {
            const result = await this.get('CountryState', country);
            return result;
        }
        else {
            return null;
        }

    }
}





// WEBPACK FOOTER //
// ./src/app/shell/forms/organizational-setup/setup/State/State.service.ts